import React, { Component, Fragment } from 'react'
import CSSModules from 'react-css-modules'

import LoginHeader from '../header/login_header'
import { localize } from 'helpers/translator'
import Bodymovin from 'components/bodymovin/bodymovin'

import styles from './login_verify_account.scss'

const invites = '/assets/media/animations/invites.json'

class LoginVerifyAccount extends Component {
	render() {
		return (
			<Fragment>
				<LoginHeader linkType='login' />
				<div styleName='container'>
					<p styleName='text'>
						{localize('verify_account_text_part1')} <strong styleName='strong'>{localize('verify_account_text_part2')}</strong> {localize('verify_account_text_part3')}<br />
						{localize('verify_account_text_part4')} {this.props.location.state.userEmail ? <strong styleName='strong'>{ this.props.location.state.userEmail }</strong> : localize('verify_account_text_placeholder')} {localize('verify_account_text_part5')}<br />
						{localize('verify_account_text_part6')}
					</p>
					<Bodymovin
						name='invites'
						path={invites}
						loop={false}
					>
						<div styleName='animation'></div>
					</Bodymovin>
				</div>

			</Fragment>
		)
	}
}

export default CSSModules(LoginVerifyAccount, styles, {allowMultiple: true})
